import _ from 'lodash';

import { getMaxLoanSizeForProduct } from '../../helpers/maxLoanSizeHelper';

/**
 * Validates the loan request fields with a passed schema
 * @param {Object} schema
 * @returns {Function}
 */
export default (schema) => {
    return (values, dispatch, props) => {
        return new Promise((resolve, reject) => {
            const loanRequest = values.loan_request;
            schema
                .validate(loanRequest, {
                    abortEarly: false,
                    currency: props.currency,
                    maxLoanSize: getMaxLoanSizeForProduct(
                        props.application,
                        props.country
                    ),
                    minLoanSize: 1000
                })
                .then(() => {
                    resolve();
                })
                .catch((errors) => {
                    let formErrors = errors.inner.reduce((memo, err) => {
                        return _.setWith(memo, err.path, err.message);
                    }, {});
                    formErrors = _.merge({ loan_request: formErrors });
                    reject(formErrors);
                });
        });
    };
};
